import { ItemsSection } from "components/ItemsSection"
import { PartnerCard } from "domains/partner/PartnerCard"
import { useTranslator } from "components/Translator"
import { Button } from "components/Button"
import * as styles from "domains/partner/PartnersSection.css?module"
import cx from "classnames"
import { Wrapper } from "components/Wrapper"

export const PartnersSection = ({ partners, color }) => {
  const translator = useTranslator()

  return (
    <ItemsSection
      title={
        <Wrapper>
          {translator.trans("PartnersSection.title", null, "components")}
        </Wrapper>
      }
      items={partners.map((partner) => (
        <div
          key={partner.id}
          className={cx("shrink-0", styles.PartnersSection__item)}
        >
          <PartnerCard partner={partner} />
        </div>
      ))}
      viewMoreButton={
        <Button
          href={{ route: "app_club_partner_index" }}
          variant="outline"
          color="primary"
        >
          {translator.trans("PartnersSection.more", null, "components")}
        </Button>
      }
      color={color}
    />
  )
}
